"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports["default"] = void 0;
var _color = require("./color");
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var theme = {
  // Light theme colors
  lightPrimary: _color.themecolor.lightPrimary,
  lightPrimaryHover: _color.themecolor.lightPrimaryHover,
  lightPrimaryActive: _color.themecolor.lightPrimaryActive,
  lightSecondary: _color.themecolor.lightSecondary,
  lightTextDefault: _color.themecolor.lightTextDefault,
  lightTextDefaultHover: _color.themecolor.lightTextDefaultHover,
  lightTextDefaultActive: _color.themecolor.lightTextDefaultActive,
  // Dark theme colors
  darkPrimary: _color.themecolor.darkPrimary,
  darkPrimaryHover: _color.themecolor.darkPrimaryHover,
  darkPrimaryActive: _color.themecolor.darkPrimaryActive,
  darkSecondary: _color.themecolor.darkSecondary,
  darkSecondaryHover: _color.themecolor.darkSecondaryHover,
  darkSecondaryActive: _color.themecolor.darkSecondaryActive,
  darkTextDefault: _color.themecolor.darkTextDefault,
  darkTextDefaultHover: _color.themecolor.darkTextDefaultHover,
  darkTextDefaultActive: _color.themecolor.darkTextDefaultActive,
  darkGray: _color.themecolor.darkGray,
  // Shared colors
  tabDefault: _color.themecolor.tabDefault,
  disabled: _color.themecolor.disabled,
  white: _color.themecolor.white,
  black: _color.themecolor.black,
  burntUmber: _color.themecolor.burntUmber,
  burntUmberHover: _color.themecolor.burntUmberHover,
  burntUmberActive: _color.themecolor.burntUmberActive,
  success: _color.themecolor.success,
  successHover: _color.themecolor.successHover,
  successActive: _color.themecolor.successActive,
  info: _color.themecolor.info,
  infoHover: _color.themecolor.infoHover,
  infoActive: _color.themecolor.infoActive,
  warning: _color.themecolor.warning,
  warningHover: _color.themecolor.warningHover,
  warningActive: _color.themecolor.warningActive,
  danger: _color.themecolor.danger,
  dangerHover: _color.themecolor.dangerHover,
  dangerActive: _color.themecolor.dangerActive,
  loading: _color.themecolor.info,
  lightGrey: _color.themecolor.lightGrey,
  lightGreyHover: _color.themecolor.lightGreyHover,
  lightGreyActive: _color.themecolor.lightGreyActive,
  lightestGrey: _color.themecolor.lightestGrey,
  lightSearchGrey: _color.themecolor.lightSearchGrey,
  lightBlue: _color.themecolor.lightBlue,
  lightBlueHover: _color.themecolor.lightBlueHover,
  lightBlueActive: _color.themecolor.lightBlueActive,
  lightPurple: _color.themecolor.lightPurple,
  lightPurpleHover: _color.themecolor.lightPurpleHover,
  lightPurpleActive: _color.themecolor.lightPurpleActive
};
exports.theme = theme;
var _default = theme;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(theme, "theme", "/Users/crs/WebstormProjects/michelangelo/src/Components/styles/theme.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/styles/theme.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();